let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9Bu2S")).then(() => parcelRequire('5W6v1'));